import React from "react";
import { Rule } from "slate-html-serializer";
import _ from "underscore";
import { BLOCK_TAG_LOOKUP, INLINE_TAG_LOOKUP, MARK_TAG_LOOKUP } from ".";

export const BlockSerialiserRule: Rule = {
  deserialize: (el, next) => {
    const type = BLOCK_TAG_LOOKUP[el.tagName.toLowerCase()];

    if (type) {
      return {
        object: "block",
        type,
        data: {
          className: el.getAttribute("class"),
        },
        nodes: next(el.childNodes),
      };
    }
  },
  serialize: (obj, children) => {
    if (obj.object === "block") {
      switch (obj.type) {
        case "code":
          return (
            <pre>
              <code>{children}</code>
            </pre>
          );
        case "paragraph":
          return <p className={obj.data.get("className")}>{children}</p>;
        case "quote":
          return <blockquote>{children}</blockquote>;
        case "h1":
        case "h2":
        case "h3":
          const Heading = obj.type;
          return <Heading>{children}</Heading>;
      }
    }
  },
};

export const InlineSerialiserRule: Rule = {
  deserialize: (el, next) => {
    const type = INLINE_TAG_LOOKUP[el.tagName.toLowerCase()];
    if (type) {
      return {
        object: "inline",
        type,
        data: {
          href: el.getAttribute("href"),
          src: el.getAttribute("src"),
          alt: el.getAttribute("alt"),
          className: el.getAttribute("class"),
        },
        nodes: next(el.childNodes),
      };
    }
  },
  serialize: (obj, children) => {
    if (obj.object === "inline") {
      let props: Record<string, string>;
      switch (obj.type) {
        case "link":
          props = {
            href: obj.data.get("href"),
            target: obj.data.get("target"),
            className: obj.data.get("class"),
          };

          return <a {...props}>{children}</a>;
        case "image":
          props = {
            src: obj.data.get("src"),
            alt: obj.data.get("alt"),
            className: obj.data.get("class"),
          };

          return <img {...props} />;
      }
    }
  },
};

export const MarkSerialiserRule: Rule = {
  deserialize: (el, next) => {
    const type = MARK_TAG_LOOKUP[el.tagName.toLowerCase()];
    if (type) {
      return {
        object: "mark",
        type,
        nodes: next(el.childNodes),
      };
    }
  },
  serialize: (obj, children) => {
    if (obj.object === "mark") {
      switch (obj.type) {
        case "bold":
          return <strong>{children}</strong>;
        case "italic":
          return <em>{children}</em>;
        case "underline":
          return <u>{children}</u>;
      }
    }
  },
};
